const operators = {
  is: (predicateValue: unknown, [value]) => value === predicateValue,
  'is-equal-to': (predicateValue: unknown, [value]) => value === predicateValue,
  'is-not': (predicateValue: unknown, [value]) => value !== predicateValue,
  'is-one-of': (predicateValue: unknown, values = []) => {
    return values.includes(predicateValue);
  },
  'is-not-one-of': (predicateValue: unknown, values?: unknown[]) => {
    return !!(values && !values.includes(predicateValue));
  },
  'ends-with': (predicateValue = '', values = []) => {
    return values.some((value) => predicateValue.endsWith(value));
  },
  'does-not-end-with': (predicateValue = '', values?: string[]) => {
    return !!(
      predicateValue &&
      values &&
      values.every((value) => !predicateValue.endsWith(value))
    );
  },
  'starts-with': (predicateValue = '', values = []) => {
    return values.some((value) => predicateValue.startsWith(value));
  },
  'does-not-start-with': (predicateValue = '', values?: string[]) => {
    return !!(
      predicateValue &&
      values &&
      values.every((value) => !predicateValue.startsWith(value))
    );
  },
  matches: (predicateValue = '', values = []) => {
    return values.some((value) => RegExp(value).test(predicateValue));
  },
  'does-not-match': (predicateValue = '', values?: RegExp[]) => {
    return !!(
      predicateValue &&
      values &&
      values.every((value) => !RegExp(value).test(predicateValue))
    );
  },
  contains: (predicateValue = [], values = []) => {
    return values.some((value) => predicateValue.includes(value));
  },
  'does-not-contain': (predicateValue: unknown[], values?: unknown[]) => {
    return !!(
      predicateValue &&
      values &&
      values.every((value) => !predicateValue.includes(value))
    );
  },
  'greater-than': (predicateValue: number, values = []) => {
    return values.some((value) => predicateValue > value);
  },
  'less-than': (predicateValue: number, values = []) => {
    return values.some((value) => predicateValue < value);
  },
  'greater-than-or-equal-to': (predicateValue: number, values = []) => {
    return values.some((value) => predicateValue >= value);
  },
  'less-than-or-equal-to': (predicateValue: number, values = []) => {
    return values.some((value) => predicateValue <= value);
  },
  every: (predicateValue: Array<unknown>, values = []) => {
    return values.every((value) => predicateValue.includes(value));
  },
};

export default operators;
